import React, { useEffect, useState, useContext } from "react";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import { Table, Form, Button, Modal, Typography } from "antd";
import DaysOfWeek from "../../../components/tables/DaysOfWeek";
import SalarySymbol from "../../../components/tables/SalarySymbol";
import ClientsTariff from "../../../components/tables/ClientsTariff";
import ContractDayType from "../../../components/tables/ContractDayType";
import Shift from "./Shift";
import { PlusOutlined, DeleteOutlined, FormOutlined } from "@ant-design/icons";
import RestrictedContext from "../../../components/util/RestrictedContext";
import moment from "moment";
var unflatten = require("flat").unflatten;
const { Text } = Typography;

const TableComponent = ({
  value,
  onChange,
  selectedVersion,
  clientTariffId,
}) => {
  const [columns, setColumns] = useState([]);
  const [visible, setVisible] = useState(false);
  const [mode, setMode] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const intl = useIntl();
  const restricted = useContext(RestrictedContext);
  useEffect(() => {
    let tableColumns = [
      {
        title: <FormattedMessage id={"app.forms.contract.shifts.day_type"} />,
        dataIndex: "day_type",
        render: (text, record, index) => <ContractDayType text={text} />,
      },
      {
        title: (
          <FormattedMessage id={"app.forms.contract.shifts.day_of_week"} />
        ),
        dataIndex: "day_of_week",
        render: (text, record, index) => <DaysOfWeek text={text} />,
      },
      {
        title: (
          <FormattedMessage
            id={"app.forms.contract.shifts.start_time_minutes"}
          />
        ),
        dataIndex: "start_time_minutes",
        render: (text, record, index) => {
          return <Text>{text && moment(text).format("HH:mm")}</Text>;
        },
      },
      {
        title: <FormattedMessage id={"app.forms.contract.shifts.end_time"} />,
        dataIndex: "start_time_minutes",
        render: (text, record, index) => {
          return (
            <Text>
              {text &&
                moment(text)
                  .add(record.end_time_minutes, "hour")
                  .format("HH:mm")}
            </Text>
          );
        },
      },
      {
        title: (
          <FormattedMessage id={"app.forms.contract.shifts.end_time_minutes"} />
        ),
        dataIndex: "end_time_minutes",
        render: (text, record, index) => {
          return (
            <Text>
              {text &&
                `${text} ${intl.formatMessage({
                  id: "app.contracts.hours",
                })}`}
            </Text>
          );
        },
      },
      {
        title: (
          <FormattedMessage id={"app.forms.contract.shifts.client_tariff_id"} />
        ),
        dataIndex: "client_tariff_id",
        render: (text, record, index) => <ClientsTariff text={text} />,
      },
      {
        title: (
          <FormattedMessage
            id={"app.forms.contract.shifts.hourly_percentage_rate"}
          />
        ),
        dataIndex: "hourly_percentage_rate",
        render: (text, record, index) => <Text>{text && `${text}%`}</Text>,
      },
      {
        title: (
          <FormattedMessage id={"app.forms.contract.shifts.salary_symbol_id"} />
        ),
        dataIndex: "salary_symbol_id",
        render: (text, record, index) => <SalarySymbol text={text} />,
      },
    ];

    if (restricted["hasWritePermission"]) {
      tableColumns.push({
        title: <FormattedMessage id={"app.forms.contract.shifts.actions"} />,
        dataIndex: "actions",
        width: "120px",
        render: (item, record, index) => (
          <div>
            <Button
              type="link"
              onClick={() => {
                onDeleteRow(record, index);
              }}
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Button>
            <Button
              type="link"
              onClick={() => {
                onEditRow(record, index);
              }}
            >
              <FormOutlined style={{}} />
            </Button>
          </div>
        ),
      });
    }

    setColumns(tableColumns);
  }, [value]);

  const onDeleteRow = (item, index) => {
    var arr = value.filter((entry) => entry !== value[index]);
    onChange(arr);
    setActiveIndex(null);
  };

  const onEditRow = (item, index) => {
    setActiveItem(item);
    setActiveIndex(index);
    setMode("edit");
    setVisible(true);
  };

  const onAddClick = () => {
    setVisible(true);
    setMode("new");
  };

  const onDecline = () => {
    setVisible(false);
  };

  const resource = "organization.settings";
  const action = "editor";
  const name = "shifts";
  const sorter = null;

  const onFinish = (values, mode) => {
    setVisible(false);
    setActiveItem(null);
    setMode(null);
    const newRecord = unflatten(values, { safe: true })["shifts"];
    const newVal = value
      ? mode === "edit"
        ? [...value.filter((item) => item !== value[activeIndex]), newRecord]
        : [...value, { ...newRecord, id: value.length + 1000 }]
      : [{ ...newRecord, id: 1 }];
    if (sorter && newVal) {
      newVal.sort(sorter);
    }
    onChange(newVal);
    setActiveIndex(null);
  };
  return (
    <div>
      {restricted["hasWritePermission"] && (
        <Button
          onClick={onAddClick}
          type="link"
          shape="circle"
          style={{
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "30px",
              height: "30px",
              borderRadius: "15px",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #584feb",
            }}
          >
            <PlusOutlined />
          </div>
          <div style={{ padding: "0 12px" }}>
            {<FormattedMessage id="app.contracts.addShift" />}
          </div>
        </Button>
      )}

      <Table
        bordered
        columns={columns}
        dataSource={value}
        size="small"
        rowKey={(record) => record.id}
      />

      <Modal
        closable={false}
        footer={null}
        maskClosable={false}
        title={null}
        width={"fit-content"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        open={visible}
        destroyOnClose={true}
      >
        <Shift
          resource={resource}
          action={action}
          name={name}
          onFinish={onFinish}
          onDecline={onDecline}
          mode={mode}
          activeItem={activeItem}
          value={value}
          selectedVersion={selectedVersion}
          clientTariffId={clientTariffId}
        />
      </Modal>
    </div>
  );
};

const Shifts = (props) => {
  const { selectedVersion, clientTariffId } = props;
  return (
    <Form.Item name={"shifts"} noStyle>
      <TableComponent
        selectedVersion={selectedVersion}
        clientTariffId={clientTariffId}
      />
    </Form.Item>
  );
};

export default Shifts;
